const isEmpty = require('lodash/isEmpty');
const omit = require('lodash/omit');
const getUrlByUid = require('./get-url-by-uid');
const { localiseUrlII } = require('./format-localised-url');
const { track } = require('../../client/js/analytics/facade');
const qs = require('qs');
const url = require('url');

/**
 * getRedirectUrl - Pass a Prismic UID, a country model and the available languages and get a localised URL.
 *
 * @param {String} uid - A Prismic document UID.
 * @param {Object} countryModel - The new country that you will be navigating to.
 * @param {Object[]} alternateLanguages - A list of languages from the Prismic Doc you will be navigation to/from.
 * @param {String} [searchQuery] - A string that attaches to the end of the path.
 * @returns {String} A localised url to either the Prismic document or the homepage.
 */
const getRedirectUrl = (uid, countryModel = {}, alternateLanguages = [], queryParams = {}) => {
  if (!uid || isEmpty(countryModel) || isEmpty(alternateLanguages)) {
    return localiseUrlII(countryModel, '/');
  }

  const doc = alternateLanguages.find(route =>
    countryModel.contentLocales.find(locales => locales === route.lang)
  );

  let route = `/`;

  // If the doc exists then set route to its url
  if (!!doc) {
    // The redirect doc may be linked to the current doc however the uid may be different - in this case
    // we set the redirect uid to be the same as the uid of the found doc.
    route = getUrlByUid(doc.uid || uid, { isUrlLocalised: false, queryParams });;
  }

  return localiseUrlII(countryModel, route);
};

/**
 * navigate - Pass a URL and some tracking information and navigate to it.
 *
 * @param {String} href - A URL path to go to
 * @param {Object} queryParams - An object of parameters to be passed to the next url
 * @param {Object} tracking - Tracking information object
 * @param {String} tracking.action -
 * @param {String} tracking.[category] - An optional string to set the category of the event
 * @param {String} tracking.from - The path/country prefix the you are coming from.
 * @param {String} tracking.to - The path/country prefix the you are going to.
 */
const navigate = (href, queryParams = {}, { action, category = 'Navigation', from = '', to = '' }) => {
  let { search } = url.parse(href);
  let query = qs.parse(search, { ignoreQueryPrefix: true });

  track(action, {
    category,
    label: `${from || 'us'} -> ${to || 'us'}`
  }).then(() => {
    if (!isEmpty(queryParams)) {
      href = href.replace(search, '');
      // In the next route we no longer need return to uid so I remove here to avoid confusion later
      query = { ...queryParams, ...query };
      query = omit(query, ['return_to_uid', 'return_to']);
      query = qs.stringify(query, { addQueryPrefix: true });

      href += query;
    }
    window.location = href;
  });
};

module.exports = {
  getRedirectUrl,
  navigate
};
